import React from 'react'

import { NYLAS_REDIRECT } from '../../../../../lib/constants'
import ConnectUserAccounts from '../../../../../pages/emailAndCalendarIntegration/components/ConnectAccounts/ConnectUserAccounts'

interface Props {
  isAtSignup: boolean
}

const ConnectEmailAndCalendar: React.FC<Props> = ({ isAtSignup }) => {
  return (
    <div className="text-start display-contents">
      <ConnectUserAccounts
        nylasRedirect={
          isAtSignup
            ? NYLAS_REDIRECT.completeRegistrationFlowAtSignup
            : NYLAS_REDIRECT.completeRegistrationFlow
        }
      />
    </div>
  )
}

export default ConnectEmailAndCalendar
